"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getWalkthroughsByIdMock = [
    {
        codeBehaviour: 'none',
        title: 'sql_injection1',
        tags: [
            {
                name: 'java',
                category: 'programming_languages',
                __typename: 'Tag',
            },
        ],
        folderStructure: {
            name: 'Root',
            type: 'Directory',
            specifiedLines: null,
            snippetId: null,
            initialCode: null,
            isIndicated: null,
            codeMirrorMode: null,
            fixedCode: null,
            markWord: [],
            fixedTooltips: [],
            fixCommands: [],
            tooltips: [],
            children: [
                {
                    _id: '60f8225fb3e126290fee177d',
                    name: '',
                    type: 'Snippet',
                    specifiedLines: null,
                    snippetId: '2e86e4b483f4b52c9c49df23032cee84f5c89e55',
                    initialCode: 'String email = request.getParameter("email");\nString password = request.getParameter("password");\n\nString sql = "select * from users where (email =\'" + email +"\' and password =\'" + password + "\')";\n\nConnection connection = pool.getConnection();\nStatement statement = connection.createStatement();\nResultSet result = statement.executeQuery(sql);\n\nif (result.next()) {\n\tloggedIn = true;\n\t// Successfully logged in and redirect to user profile page\n} else {\n\n\t// Auth failure - Redirect to Login Page\n}\n',
                    fixedCode: '',
                    markWord: [],
                    fixedTooltips: [],
                    fixCommands: [],
                    tooltips: [
                        {
                            text: 'Tooltip 1',
                            position: {
                                line: 0,
                                ch: 9,
                            },
                        },
                        {
                            text: 'Tooltip 2',
                            position: {
                                line: 1,
                                ch: 9,
                            },
                        },
                        {
                            text: 'Tooltip 3',
                            position: {
                                line: 3,
                                ch: 8,
                            },
                        },
                        {
                            text: 'Tooltip 4',
                            position: {
                                line: 7,
                                ch: 36,
                            },
                        },
                    ],
                    connectToStep: [],
                    children: [],
                },
            ],
            __typename: 'FolderStructure',
        },
        __typename: 'Walkthrough',
    },
];
exports.default = getWalkthroughsByIdMock;
